import PageShell from "@/components/PageShell";
import ContactForm from "@/components/ContactForm";

export default function Contatti() {
  return (
    <PageShell testid="contatti-page">
      <ContactForm />
    </PageShell>
  );
}
